const mediationLabels = [
  {
    title: 'Quantidade',
    content: 'quant',
    isNumber: true,
    canSort: true,
  },

  {
    title: 'Descrição',
    content: 'desc',
    canSort: true,
  },
  {
    title: 'Valor unitário',
    content: 'totalValue',
    canSort: true,
  },
];

const extractlabels = [
  {
    title: 'N° fatura',
    content: 'id',
  },

  {
    title: 'Data da emissão',
    content: 'date',
  },
  {
    title: 'Vencimento',
    content: 'expireDate',
  },
  {
    title: 'Demonstrativo',
    content: 'value',
  },
];

const paymentlabels = [
  {
    title: 'Forma de pagamento',
    content: 'type',
  },
  {
    title: 'Banco',
    content: 'bank',
  },

  {
    title: 'Código de barras',
    content: 'code',
  },
];

export { mediationLabels, extractlabels, paymentlabels };
